import { fetch } from '@utils/utils';
import * as T from '@modules/hr-templates/calendars/_calendarsTypes';

const getCalendarTemplate = ({ addError }) => async (id: string): Promise<T.Calendar | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/calendar/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Calendar = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getCalendarTemplate };



// WEBPACK FOOTER //
// ./src/modules/hr-templates/calendars/_calendarActions.ts